fragment DashboardStatsFragment on Stat {
    name
    formattedValue
    delta {
        direction
        percentChange
        timespanSuffix
    }
}
